import { CityLedgerResult } from '@mews-commander/data-access';
import { AccountsTableData } from '../types';

export const transformAccountsData = (
    accountsData?: CityLedgerResult
): { accounts: AccountsTableData[]; totalRowCount: number } => {
    if (!accountsData || !accountsData.accounts) return { accounts: [], totalRowCount: 0 };

    const accounts = accountsData.accounts.map((account) => {
        const transformedAccount = {} as AccountsTableData;

        delete Object.assign(transformedAccount, account, {
            id: account.ownerId,
            accountId: account.ownerId,
            subRows: account.invoices?.map((invoice) => ({
                ...invoice,
                id: invoice.invoiceId,
                accountId: account.ownerId,
                ownerId: account.ownerId,
                ownerName: account.ownerName,
                ownerEmail: account.ownerEmail,
            })),
        }).invoices;

        return transformedAccount;
    });

    return {
        accounts,
        totalRowCount: accountsData.totalRowCount,
    };
};
